import Aegis from '@tencent/aegis-web-sdk-v2';
import Record, { shadowDomPlugin } from '@tencent/aegis-web-record';
import { UserInfo } from '@types';
import { getStaffName } from './utils';
import { isProd } from './getEnv';
const url = 'https://galileotelemetry.tencent.com/collect'; //伽利略上报地址，不变
const id = 'SDK-c788cb9c7a639dc433ff'; // 项目token

export function configureGalio (userInfo: UserInfo) {
  if (isProd && userInfo && userInfo.salesName) {
    window.AegisV2 = new Aegis({
      id, // 项目token，即上报伽利略监控的唯一标识
      hostUrl: { url },
      plugin: {
        device: true, // 默认开启device收集器
        close: true, // 默认开启close收集器
        aid: true, // 默认开启aid收集器
        fId: false, // 默认关闭fingerId
        ie: false, // 默认关闭ie收集器

        // 页面访问
        pv: true, // 默认开启pv收集器
        spa: true, // 默认开启spa收集器

        // 勾选异常分析
        error: true, // 默认开启error收集器

        // 勾选静态资源监控
        assetSpeed: true, // 默认开启assetSpeed收集器

        // 勾选页面性能
        pagePerformance: true, // 默认开启pagePerformance收集器
        webVitals: true, // 默认开启webVitals收集器

        // 勾选session功能
        session: true,

        // 同时勾选api和trace或者仅勾选trace
        api: {
          // 勾选trace功能
          injectTraceHeader: 'traceparent', // session串联后端
          injectTraceUrls: [/xxxx.com/, /xxx.com/, /xxx.com/], // session串联后端
        },

      },
    });
    const record = new Record({
      // 填你在伽利略页面申请的可观测对象 token，token 见下图
      topic: id,
      uid: getStaffName(userInfo?.salesName, userInfo?.salesNameCh),
      // 如果你使用了 aegis-web-sdk ，可以将 aegis instance 传进来，这样 replay 和 session 数据可以关联起来
      aegisInstance: window.AegisV2, // window.AegisV2 = new Aegis({})
      plugins: [
        // @ts-ignore 是否使用 shadow-dom，未使用可不传，可减小SDK体积
        shadowDomPlugin
      ],
      // 是否屏蔽所有文本
      privacyLevel: 'none', // mask-all 屏蔽所有文本,图片,canvas等内容, mask-input 屏蔽输入框内容, none 不屏蔽

      // 重要的特性! 元素选择器，标记哪些节点内容/属性是稳定的,即如果所有所有用户访问,它的内容都是一样的,那么可以将它标记为稳定内容,所有用户只需要采集1次。
      // 比如 iconfont svg 图标，每个用户访问都是一样的，那么可以将它标记为稳定内容，这样在上报时，所有用户只需要上报1次，减少上报和存储
      stableBigAttributeSelector: 'symbol path,symbol image',
      // 标记为大内容, 元素选择器，控制需要保留的节点属性内容。默认会将比较大的属性节点内容忽略，如果需要保留，需要在这里设置
      keepBigAttributeSelector: 'path,image',
      // 页面端暂未支持,可先填上 formal test
      env: 'formal',
      // 默认不采集带 - 的标签名，这是为了防止采集浏览器插件元素，插件元素内容比较不可控 ，如果你的页面有这种节点，需要指定
      // 比如使用了无界框架的为前端项目，需要指定 wujie-app。注意，微前端项目不需要在每个包都 new Record ，在 main 包 new 即可
      // allowDashTag:"aaa-bbb,ccc-ddd",
      // 开启后，需要主动调用 record.report() 才会上报
      // manualReport:true,

      DEBUGGER: false, // 调试开关,打开后,可以看到采集的内容
    });
  }
}
